var render, staticRenderFns
import script from "./ac-data-table-bulk-rmv.vue?vue&type=script&lang=js"
export * from "./ac-data-table-bulk-rmv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c166768')) {
      api.createRecord('1c166768', component.options)
    } else {
      api.reload('1c166768', component.options)
    }
    
  }
}
component.options.__file = "src/components/Table/ac-data-table-bulk-rmv.vue"
export default component.exports